import {Component} from '@angular/core';
import {WaTextDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-architecture-aside',
	templateUrl:'./ArchitectureAsidePage.html',
	styles: [],
	styleUrls:['./ArchitectureAsidePage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaTextDirective,
],
	standalone:true
})
export class ArchitectureAsidePage
{
}
